export default function Node_DNS() {
  return <div>Node_DNS Component</div>;
}
